/* ==========================================================================
   FIGHTLAB — storefront behaviour
   Vanilla JS, no dependencies. Progressive: every interaction has a
   non-JS fallback (real links, real <form> posts to Shopify routes).
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.routes || {};
  var strings = window.fightlabStrings || {};
  var root = routes.root || '/';

  /* ---------------------------------------------------------------- utils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  function formatMoney(cents) {
    var fmt = window.fightlabMoneyFormat || '€{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount}}', withSep + '.' + parts[1])
      .replace('{{amount_no_decimals}}', withSep)
      .replace('{{amount_with_comma_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/<\/?[^>]+(>|$)/g, '');
  }

  function trapFocus(container) {
    if (!container) return;
    var focusables = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    focusables[0].focus();
    container.__trap = function (e) {
      if (e.key !== 'Tab') return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', container.__trap);
  }
  function releaseFocus(container) {
    if (container && container.__trap) container.removeEventListener('keydown', container.__trap);
  }

  var scrollLocked = 0;
  function lockScroll() { scrollLocked++; document.documentElement.style.overflow = 'hidden'; }
  function unlockScroll() { scrollLocked = Math.max(0, scrollLocked - 1); if (!scrollLocked) document.documentElement.style.overflow = ''; }

  /* --------------------------------------------------------------- drawers */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lockScroll();
    trapFocus($('.drawer__panel', el));
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    unlockScroll();
    releaseFocus($('.drawer__panel', el));
  }
  window.FIGHTLAB = window.FIGHTLAB || {};
  window.FIGHTLAB.openDrawer = openDrawer;
  window.FIGHTLAB.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
      return;
    }
    if (e.target.classList && e.target.classList.contains('drawer__overlay')) {
      closeDrawer(e.target.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    var sp = $('.search-panel.is-open');
    if (sp) closeSearch();
    $$('.nav__item[data-open="true"]').forEach(function (i) { i.setAttribute('data-open', 'false'); });
  });

  /* ------------------------------------------------------------ mega menu */
  function initNav() {
    $$('.nav__item--has-menu').forEach(function (item) {
      var link = $('.nav__link', item);
      var close;
      function open() { clearTimeout(close); item.setAttribute('data-open', 'true'); if (link) link.setAttribute('aria-expanded', 'true'); }
      function shut() { close = setTimeout(function () { item.setAttribute('data-open', 'false'); if (link) link.setAttribute('aria-expanded', 'false'); }, 120); }
      on(item, 'mouseenter', open);
      on(item, 'mouseleave', shut);
      on(item, 'focusin', open);
      on(item, 'focusout', function (e) { if (!item.contains(e.relatedTarget)) shut(); });
      on(link, 'click', function (e) {
        if (window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          item.setAttribute('data-open', item.getAttribute('data-open') === 'true' ? 'false' : 'true');
        }
      });
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest('.mnav__toggle');
      if (!t) return;
      var group = t.closest('.mnav__group');
      var open = group.getAttribute('data-open') === 'true';
      group.setAttribute('data-open', open ? 'false' : 'true');
      t.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* --------------------------------------------------------------- search */
  function openSearch() {
    var panel = $('.search-panel');
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    lockScroll();
    var input = $('input[name="q"]', panel);
    if (input) setTimeout(function () { input.focus(); }, 60);
  }
  function closeSearch() {
    var panel = $('.search-panel');
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }
  window.FIGHTLAB.openSearch = openSearch;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    var term = e.target.closest('[data-search-term]');
    if (term) {
      var panel = $('.search-panel');
      var input = $('input[name="q"]', panel);
      if (input) { input.value = term.getAttribute('data-search-term'); input.form.submit(); }
    }
  });

  /* ----------------------------------------------------------------- cart */
  function sectionsToRender() {
    var ids = [];
    if ($('#cart-drawer-content')) ids.push('cart-drawer');
    if ($('[data-cart-count]')) ids.push('header');
    return ids.join(',');
  }

  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = parsed.querySelector('#cart-drawer-content');
      var current = $('#cart-drawer-content');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    if (sections['header']) {
      var ph = new DOMParser().parseFromString(sections['header'], 'text/html');
      var nb = ph.querySelector('[data-cart-count]');
      var cb = $('[data-cart-count]');
      if (nb && cb) { cb.textContent = nb.textContent; cb.hidden = nb.hidden; }
    }
  }

  function refreshCartCount(cart) {
    var bubble = $('[data-cart-count]');
    if (!bubble || !cart) return;
    bubble.textContent = cart.item_count;
    bubble.hidden = cart.item_count === 0;
  }

  function addToCart(variantId, quantity, button) {
    if (!variantId) return Promise.reject();
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }

    return fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }],
        sections: sectionsToRender(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) throw new Error(data.description || data.message);
        renderSections(data.sections);
        return fetch((routes.cart_url || '/cart') + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartCount(cart);
        document.dispatchEvent(new CustomEvent('fightlab:cart:updated', { detail: { cart: cart } }));
        openDrawer($('#cart-drawer'));
        return cart;
      })
      .catch(function (err) {
        console.error('[FIGHTLAB] add to cart failed', err);
        alertInline(button, (err && err.message) || strings.cartError || 'Could not add to cart.');
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
      });
  }
  window.FIGHTLAB.addToCart = addToCart;

  function alertInline(button, message) {
    if (!button) return;
    var host = button.closest('form') || button.parentElement;
    if (!host) return;
    var box = host.querySelector('.form-error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'form-error';
      host.appendChild(box);
    }
    box.textContent = message;
  }

  function changeLine(key, quantity, el) {
    if (el) el.closest('.cart-line') && el.closest('.cart-line').classList.add('is-loading');
    return fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: sectionsToRender(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderSections(cart.sections);
        refreshCartCount(cart);
        document.dispatchEvent(new CustomEvent('fightlab:cart:updated', { detail: { cart: cart } }));
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick && !quick.disabled) {
      e.preventDefault();
      addToCart(quick.getAttribute('data-variant-id'), 1, quick);
      return;
    }


    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-key'), 0, remove);
      return;
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.qty');
      var input = $('input', wrap);
      var next = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-key'), parseInt(input.value, 10) || 0, input);
  });

  /* ------------------------------------------------------- product page */
  function initProductForms() {
    $$('[data-product-root]').forEach(function (root) {
      if (root.__init) return;
      root.__init = true;
      try { initProductForm(root); } catch (err) { console.error('[FIGHTLAB] product form', err); }
    });
  }

  function initProductForm(root) {
    var form = $('[data-product-form]', root);
    if (!form) return;

    var dataEl = $('[data-variant-data]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var selected = {};
    var submit = $('[data-add-to-cart]', form);
    var idInput = $('[data-variant-id]', form);
    var priceHost = $('[data-price-host]', root);
    var warning = $('[data-size-warning]', form);
    var sizeOptionName = (form.getAttribute('data-size-option') || 'Size').toLowerCase();

    $$('[data-option-value]', form).forEach(function (btn) {
      if (btn.getAttribute('aria-pressed') === 'true' || btn.classList.contains('is-active')) {
        selected[btn.getAttribute('data-option-name')] = btn.getAttribute('data-option-value');
      }
    });

    function matching() {
      return data.variants.filter(function (v) {
        return Object.keys(selected).every(function (name) {
          return v.options_map[name] === selected[name];
        });
      });
    }

    function availabilityFor(optionName, value) {
      var probe = Object.assign({}, selected);
      probe[optionName] = value;
      return data.variants.some(function (v) {
        return v.available && Object.keys(probe).every(function (n) { return v.options_map[n] === probe[n]; });
      });
    }

    function update() {
      $$('[data-option-value]', form).forEach(function (btn) {
        var name = btn.getAttribute('data-option-name');
        var value = btn.getAttribute('data-option-value');
        var active = selected[name] === value;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
        if (name.toLowerCase() === sizeOptionName) {
          var ok = availabilityFor(name, value);
          btn.classList.toggle('is-unavailable', !ok);
          btn.disabled = !ok;
        }
      });

      var found = matching()[0];
      var complete = Object.keys(selected).length === data.option_names.length;

      if (found && complete) {
        if (idInput) idInput.value = found.id;
        if (priceHost && found.price_html) priceHost.innerHTML = found.price_html;
        submit.disabled = !found.available;
        submit.textContent = found.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
        if (warning) warning.textContent = '';
        var url = new URL(window.location.href);
        url.searchParams.set('variant', found.id);
        window.history.replaceState({}, '', url.toString());
        swapGallery(found);
        syncSticky(found);
      } else {
        submit.disabled = true;
        submit.textContent = strings.selectSize || 'Select a size';
      }
    }

    function swapGallery(variant) {
      var host = $('[data-gallery]', root);
      if (!host || !variant || !variant.color) return;
      $$('[data-color-art]', host).forEach(function (node) {
        node.hidden = node.getAttribute('data-color-art') !== variant.color;
      });
    }

    function syncSticky(variant) {
      var sticky = $('[data-sticky-price]', document);
      if (sticky && variant && variant.price_html) sticky.innerHTML = variant.price_html;
    }

    on(form, 'click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      selected[btn.getAttribute('data-option-name')] = btn.getAttribute('data-option-value');
      update();
    });

    on(form, 'submit', function (e) {
      if (!idInput || !idInput.value) { e.preventDefault(); return; }
      e.preventDefault();
      var qty = $('[name="quantity"]', form);
      addToCart(idInput.value, qty ? qty.value : 1, submit);
    });

    on($('[data-sticky-atc-btn]'), 'click', function () {
      if (submit.disabled) {
        var sizes = $('.sizes', form);
        if (sizes) {
          sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (warning) warning.textContent = strings.selectSizeHelp || 'Choose a size to continue.';
        }
        return;
      }
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });

    update();
  }

  /* --------------------------------------------------- sticky add to cart */
  function initStickyAtc() {
    var bar = $('.sticky-atc');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(anchor);
  }

  /* ------------------------------------------------------------- filters */
  function initFacets() {
    var forms = $$('[data-facet-form]');
    forms.forEach(function (form) {
      on(form, 'change', function () {
        if (form.getAttribute('data-auto') === 'false') return;
        submitFacets(form);
      });
      $$('[data-facet-toggle]', form).forEach(function (btn) {
        on(btn, 'click', function (e) {
          e.preventDefault();
          var input = document.getElementById(btn.getAttribute('data-facet-toggle'));
          if (!input) return;
          input.checked = !input.checked;
          btn.classList.toggle('is-active', input.checked);
          submitFacets(form);
        });
      });
    });

    function submitFacets(form) {
      var params = new URLSearchParams(new FormData(form));
      var url = form.getAttribute('action') + '?' + params.toString();
      window.location.href = url.replace(/\?$/, '');
    }
  }

  /* ------------------------------------------------------------- reveals */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------------- announcement */
  function initAnnouncement() {
    var items = $$('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  }

  /* ------------------------------------------------------------ newsletter */
  function initForms() {
    $$('[data-newsletter]').forEach(function (form) {
      on(form, 'submit', function () { form.classList.add('is-loading'); });
    });
  }

  /* ------------------------------------------------------------ recently */
  function rememberProduct() {
    var root = $('[data-product-root]');
    if (!root) return;
    try {
      var handle = root.getAttribute('data-product-handle');
      var seen = JSON.parse(localStorage.getItem('fightlab:recent') || '[]');
      seen = [handle].concat(seen.filter(function (h) { return h !== handle; })).slice(0, 8);
      localStorage.setItem('fightlab:recent', JSON.stringify(seen));
    } catch (e) { /* storage unavailable — non-critical */ }
  }

  /* --------------------------------------------------------------- quotes */
  function initQuotes() {
    $$('[data-quote-band]').forEach(function (band) {
      if (band.__init) return;
      band.__init = true;
      var slides = $$('.quote-slide', band);
      var dots = $$('[data-quote-dot]', band);
      if (slides.length < 2) return;
      var i = 0, timer;

      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          d.setAttribute('aria-selected', String(k === i));
        });
      }
      function start() {
        if (band.getAttribute('data-rotate') !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        stop();
        timer = setInterval(function () { show(i + 1); }, parseInt(band.getAttribute('data-interval'), 10) || 7000);
      }
      function stop() { clearInterval(timer); }

      dots.forEach(function (d) {
        on(d, 'click', function () { show(parseInt(d.getAttribute('data-quote-dot'), 10)); start(); });
      });
      on(band, 'mouseenter', stop);
      on(band, 'mouseleave', start);
      on(band, 'focusin', stop);
      start();
    });
  }

  /* ----------------------------------------------------------- size chart */
  function convertCell(td, unit) {
    var cm = td.getAttribute('data-cm');
    if (cm == null) return;
    if (unit === 'cm') { td.textContent = cm; return; }
    td.textContent = cm.replace(/\d+(?:[.,]\d+)?/g, function (n) {
      var v = parseFloat(n.replace(',', '.')) / 2.54;
      return (Math.round(v * 10) / 10).toString();
    });
  }

  function initSizeChart() {
    $$('[data-size-chart]').forEach(function (root) {
      if (root.__init) return;
      root.__init = true;

      $$('[data-sc-tab]', root).forEach(function (tab) {
        on(tab, 'click', function () {
          var idx = tab.getAttribute('data-sc-tab');
          $$('[data-sc-tab]', root).forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', String(active));
          });
          $$('[data-sc-panel]', root).forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-sc-panel') === idx);
          });
        });
      });

      $$('[data-unit]', root).forEach(function (btn) {
        on(btn, 'click', function () {
          var unit = btn.getAttribute('data-unit');
          $$('[data-unit]', root).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          $$('td[data-cm]', root).forEach(function (td) { convertCell(td, unit); });
        });
      });
    });
  }

  /* ---------------------------------------------------------------- boot */
  function boot() {
    initNav();
    initProductForms();
    initStickyAtc();
    initFacets();
    initReveal();
    initAnnouncement();
    initForms();
    initQuotes();
    initSizeChart();
    rememberProduct();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-initialise when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function () { boot(); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#cart-drawer')) openDrawer($('#cart-drawer'));
  });
})();
